import { render } from "./userEidt.vue?vue&type=template&id=3c816b1a&scoped=true"
import script from "./userEidt.vue?vue&type=script&lang=js"
export * from "./userEidt.vue?vue&type=script&lang=js"

import "./userEidt.vue?vue&type=style&index=0&id=3c816b1a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c816b1a"]])

export default __exports__